import { MaterialType } from "./material.type";
import { UserResponse } from "./user.type";

export enum CategoryTypes {
  GOODS = "GOODS",
  SERVICES = "SERVICES",
}

export enum CategoryType {
  INDIRECT_GOODS = "INDIRECT_GOODS",
  DIRECT_GOODS = "DIRECT_GOODS",
  SERVICES = "SERVICES",
}

export interface ParentCategory {
  active: boolean;
  createdAt: string;
  id: string;
  name: string;
  nameEn: string;
  parent: ParentCategory;
  type: string;
  updatedAt: string;
}

export interface CategoryResponse {
  active: boolean;
  createdAt: string;
  id: string;
  name: string;
  nameEn: string;
  type: MaterialType;
  updatedAt: string;
  selected?: boolean;
}

export interface UserMaterialCategory {
  createdAt: string;
  updatedAt: string;
  id: string;
  category: CategoryResponse;
  user: UserResponse;
  active: boolean;
}
